// extracted by mini-css-extract-plugin
export default {"detailsRadio":"styles-module__P7hDG","integrationsLabel":"styles-module__DA5F2"};